__turbopack_context__.v({
  "body": "cardPrice-module__nEVfdq__body",
  "bodyHeading": "cardPrice-module__nEVfdq__bodyHeading",
  "bodyParagraph": "cardPrice-module__nEVfdq__bodyParagraph",
  "bullets": "cardPrice-module__nEVfdq__bullets",
  "buttons": "cardPrice-module__nEVfdq__buttons",
  "checkCircle": "cardPrice-module__nEVfdq__checkCircle",
  "checkPlaceholder": "cardPrice-module__nEVfdq__checkPlaceholder",
  "clickable": "cardPrice-module__nEVfdq__clickable",
  "content": "cardPrice-module__nEVfdq__content",
  "ctaButton": "cardPrice-module__nEVfdq__ctaButton",
  "deviceCount": "cardPrice-module__nEVfdq__deviceCount",
  "feature": "cardPrice-module__nEVfdq__feature",
  "featureGroup": "cardPrice-module__nEVfdq__featureGroup",
  "featureSubtitle": "cardPrice-module__nEVfdq__featureSubtitle",
  "featureTitle": "cardPrice-module__nEVfdq__featureTitle",
  "features": "cardPrice-module__nEVfdq__features",
  "header": "cardPrice-module__nEVfdq__header",
  "inlineBadge": "cardPrice-module__nEVfdq__inlineBadge",
  "planBadge": "cardPrice-module__nEVfdq__planBadge",
  "planSavings": "cardPrice-module__nEVfdq__planSavings",
  "planSavingsBadge": "cardPrice-module__nEVfdq__planSavingsBadge",
  "planSavingsSale": "cardPrice-module__nEVfdq__planSavingsSale",
  "planTitle": "cardPrice-module__nEVfdq__planTitle",
  "price": "cardPrice-module__nEVfdq__price",
  "priceCadence": "cardPrice-module__nEVfdq__priceCadence",
  "priceDetails": "cardPrice-module__nEVfdq__priceDetails",
  "pricePerSeat": "cardPrice-module__nEVfdq__pricePerSeat",
  "priceRow": "cardPrice-module__nEVfdq__priceRow",
  "root": "cardPrice-module__nEVfdq__root",
  "rootSelectable": "cardPrice-module__nEVfdq__rootSelectable",
  "savingsRow": "cardPrice-module__nEVfdq__savingsRow",
  "savingsText": "cardPrice-module__nEVfdq__savingsText",
  "selectable": "cardPrice-module__nEVfdq__selectable",
  "strikeoutPrice": "cardPrice-module__nEVfdq__strikeoutPrice",
  "subtitle": "cardPrice-module__nEVfdq__subtitle",
  "titleGroup": "cardPrice-module__nEVfdq__titleGroup",
  "titleRow": "cardPrice-module__nEVfdq__titleRow",
});
